import React, { useState, useEffect } from 'react';
import ReactDOM from "react-dom";
import UseContext from "hooks/useContext";
import SlideOverStructure from "../component/structure";
import DataSlideOver from "../dataSlideOver";
import { INVOICE_DETAIL_SLIDE_OVER } from "components/invoiceDetail/useOpenInvoiceDetail";
import { APPOINTMENT_PANEL } from "hooks/useAppointmentPanel";
import { RECORD_FORM_PANEL } from "hooks/useRecordPanels";
import { TASK_FORM_PANEL, TASK_PANEL } from "hooks/useTaskPanels";
import { CREATE_MENU_PANEL } from "components/sidebar/CreateMenuPanel";
import { MENTIONS_PANEL } from "components/home/MentionsPanel";
import { REVIEW_PANEL } from "components/stats/ReviewPanel";

// Panels wider than the default 800 px: the invoice detail shows its PDF
// beside its information (JBWEB-1274).
const PANEL_WIDTHS = {
    [INVOICE_DETAIL_SLIDE_OVER]: 'lg:w-[1200px]',
    [RECORD_FORM_PANEL]: 'lg:w-[600px]',
    [APPOINTMENT_PANEL]: 'lg:w-[600px]',
    [CREATE_MENU_PANEL]: 'lg:w-[600px]',
    [MENTIONS_PANEL]: 'lg:w-[600px]',
    [REVIEW_PANEL]: 'lg:w-[600px]',
};

const Index = () => {
    const {slideOverShow, slideOverType} = UseContext()
    const [showCV, setShowCV] = useState(false);

    // Réinitialiser showCV quand le slideOver se ferme ou change de type
    useEffect(() => {
        if (!slideOverShow || slideOverType !== 'get_temp_worker') {
            setShowCV(false);
        }
    }, [slideOverShow, slideOverType]);

    if(!slideOverShow) return null
    // The task's panel and form draw their own Drawer (components/crm/ui), portalled to body.
    if (slideOverType === TASK_PANEL || slideOverType === TASK_FORM_PANEL) return <DataSlideOver />;

    return ReactDOM.createPortal(
        <SlideOverStructure isShowing={slideOverShow} showCV={showCV && slideOverType === 'get_temp_worker'} width={PANEL_WIDTHS[slideOverType]}>
            <DataSlideOver setShowCV={setShowCV} />
        </SlideOverStructure>
        , document.getElementById('root-portal'));
};

export default Index;